import type { FC } from 'react';

interface Props {
  height?: number;
  width?: number;
  fill?: string;
}
const ClockPhoneIcon: FC<Props> = ({
  height = 12,
  width = 14,
  fill = '#2C2543',
}) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_16021_15009)">
      <path
        d="M6 2.5V5.5L7.86919 6.43459M10.283 2.91866C9.4075 1.46913 7.81693 0.5 6 0.5C3.23858 0.5 1 2.73858 1 5.5C1 7.87145 2.65095 9.8573 4.86619 10.3709"
        stroke={fill}
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2497 6.02879C11.0396 6.65044 10.7117 7.25546 10.2617 7.81789C9.8116 8.38033 9.2752 8.85538 8.68166 9.23805C8.63061 9.27097 8.60508 9.28743 8.57178 9.30241C8.45344 9.35566 8.29746 9.3586 8.18119 9.30978C8.14847 9.29605 8.11939 9.27792 8.06123 9.24167C7.88336 9.13081 7.79443 9.07538 7.70913 9.04379C7.38743 8.92463 7.00999 8.98914 6.74614 9.20839C6.67617 9.26652 6.6107 9.34835 6.47975 9.51199L6.40676 9.6032C6.20771 9.85196 6.10818 9.97634 6.06358 10.0993C5.97487 10.3438 6.01985 10.6069 6.18472 10.8081C6.26763 10.9092 6.40282 10.9935 6.6732 11.162L6.7534 11.212C7.02285 11.3799 7.15758 11.4639 7.33016 11.5161C7.52167 11.574 7.80654 11.5905 8.00883 11.5554C8.19113 11.5238 8.31041 11.471 8.54895 11.3655C9.83091 10.7985 10.9861 9.94466 11.8805 8.82689C12.775 7.70912 13.3004 6.46275 13.4771 5.20688C13.51 4.97319 13.5264 4.85634 13.4992 4.69413C13.4691 4.51414 13.3562 4.28272 13.2303 4.14282C13.1168 4.01674 12.982 3.93277 12.7126 3.76483L12.6324 3.71485C12.362 3.54633 12.2268 3.46207 12.0911 3.42694C11.8212 3.35709 11.5251 3.40769 11.2937 3.56323C11.1774 3.64145 11.0778 3.76583 10.8788 4.01458L10.8058 4.1058C10.6748 4.26944 10.6094 4.35126 10.5707 4.4289C10.4248 4.72168 10.4822 5.05718 10.717 5.28489C10.7793 5.34527 10.8682 5.4007 11.0461 5.51156C11.1042 5.54781 11.1333 5.56593 11.1589 5.58855C11.2499 5.66893 11.299 5.79965 11.2817 5.91588C11.2768 5.94859 11.2678 5.97532 11.2497 6.02879Z"
        stroke={fill}
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_16021_15009">
        <rect width={width} height={height} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ClockPhoneIcon;
